import { styled } from "@mui/styles";
import { FiTrash2 } from "react-icons/fi";

import { Button, Input } from "../../../../../../Form";

export const SubTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "23px",
  textAlign: "left",
  color: "#475467",
}));

export const BorderShiftCard = styled("div")(() => ({
  borderRadius: "8px",
  border: "1px solid #D0D5DD",
  width: "100%",
  minHeight: "216px",
  padding: "24px",

  display: "flex",
  flexDirection: "column",
}));

export const WeekDayButton = styled("a")<{ selected?: boolean }>(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",

  borderRadius: "8px",
  border: theme?.selected ? "1px solid #0055A4" : "1px solid #D0D5DD",
  background: theme?.selected ? "#F1F6FB" : "#FFF",
  color: theme?.selected ? "#0055A4" : "#475467",
  width: "42px",
  height: "42px",

  cursor: "pointer",
}));

export const Row = styled("div")<{ gap?: string }>(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme?.gap || "10px",
}));

export const Column = styled("div")<{ gap?: string }>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  gap: theme?.gap || "10px",
}));

export const TimeInput = styled(Input)(() => ({
  "& input::-webkit-calendar-picker-indicator": {
    background: "none",
    display: "none",
  },
}));

export const SecondShiftButton = styled(Button)(() => ({
  color: "#0055A4",
  paddingLeft: "0px",
  paddingRight: "0px",
}));

export const TrashIcon = styled(FiTrash2)(() => ({
  color: "#475467",
  cursor: "pointer",
}));
